module.exports = __webpack_public_path__ + "img/2.bf8a2b5a.png";